import { msg, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import React, { useEffect } from 'react';
import { Button } from '../../Components/BaseComponents/Button';
import { Modal } from '../../Components/Modals/Modal';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
import { SwipeluxLogo } from '../../Pages/OrderDetailsPage/icons';
export function OrderHistoryModal(props) {
    const { _ } = useLingui();
    const { track } = useAnalytics();
    useEffect(() => {
        track('order_history_modal_viewed');
    }, [track]);
    return (<Modal className="relative flex flex-col" label={<SwipeluxLogo />} dataTestIdPrefix="history" {...props}>
      <ul className="flex flex-col pointer-events-none">
        <OrderHistoryItem fromValue="20 EUR" toValue="100 POL" fromIcon="https://swipelux-static-images-global-s3.s3.eu-central-1.amazonaws.com/Flags/EU.svg" toIcon="https://swipelux-static-images-global-s3.s3.eu-central-1.amazonaws.com/crypto/MATIC.svg" date="April 2nd, 4:00 PM"/>

        <OrderHistoryItem fromValue="40 USD" toValue="38.5 USDC" fromIcon="https://swipelux-static-images-global-s3.s3.eu-central-1.amazonaws.com/Flags/US.svg" toIcon="https://swipelux-static-images-global-s3.s3.eu-central-1.amazonaws.com/crypto/USDC.svg" date="March 26th, 12:30 PM"/>

        <OrderHistoryItem fromValue="100 USD" toValue="99.5 USDC" fromIcon="https://swipelux-static-images-global-s3.s3.eu-central-1.amazonaws.com/Flags/US.svg" toIcon="https://swipelux-static-images-global-s3.s3.eu-central-1.amazonaws.com/crypto/MATIC.svg" date="March 24th, 6:40 PM"/>
      </ul>

      {/* <div className="absolute inset-0 [mask-image:linear-gradient(to_bottom,transparent,black_30%)] backdrop-blur-lg"> */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background to-30%">
        <div className="h-full flex flex-1 flex-col p-[var(--web-sides-padding)]">
          <div className="flex flex-1 gap-4 flex-col pt-16 items-center justify-center">
            <h2 className="text-2xl font-semibold leading-tight text-center text-textBodyMain text-balance px-[var(--web-sides-padding)]">
              <Trans>Order history is coming soon</Trans>
            </h2>

            <div className="flex flex-col gap-2">
              <p className="text-sm leading-snug text-textBodyAdd text-center text-balance">
                <Trans>
                  We&apos;re currently developing this feature, please check
                  back later.
                </Trans>
              </p>

              <p className="text-sm leading-snug text-textBodyAdd text-center text-balance">
                <Trans>
                  For now, we suggest checking your emails to see your order
                  history.
                </Trans>
              </p>
            </div>
          </div>

          <div className="flex">
            <Button onClick={props.onClose} label={_(msg `Got it`)}/>
          </div>
        </div>
      </div>
    </Modal>);
}
function OrderHistoryItem(props) {
    return (<li className="flex items-center gap-4 py-3 px-[var(--web-sides-padding)]">
      <div className="relative w-8 h-8">
        <img className="absolute top-0 size-6" src={props.fromIcon}/>
        <img className="absolute top-2 left-2 border-2 box-content border-background rounded-full object-cover size-6" src={props.toIcon}/>
      </div>

      <div className="flex flex-col">
        <div className="flex items-center gap-1 text-textBodyMain">
          <span className="text-base">{props.fromValue}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14"/>
            <path d="m12 5 7 7-7 7"/>
          </svg>
          <span className="text-base">{props.toValue}</span>
        </div>

        <time className="block text-sm text-textBodyAdd">{props.date}</time>
      </div>
    </li>);
}
